
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusaundh() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Aundh',
        heading: 'etravo :  Corporate Cab and Bus Services in Aundh',
        headingDescription: 'eTravo provides premium Corporate Cab and Bus Services in Aundh, Pune, tailored to the dynamic needs of modern businesses. Whether it is executive cabs for senior management and client visits or corporate buses for daily employee commutes and team outings, we ensure reliable, on-time, and comfortable travel. Our professionally managed fleet, equipped with business-class amenities and GPS tracking, offers a seamless mobility experience. Choose eTravo in Aundh for smart, safe, and scalable transportation solutions that support your corporate efficiency.',

        top: 'Top Places to Visit in Aundh with etravo',
 "topPlaces": [
    {
      "title": "Westend Mall",
      "description": "Located in Aundh near Parihar Chowk, Westend Mall is a popular shopping and entertainment destination. It features a wide range of retail stores, restaurants, and Pune's first IMAX theater, making it a perfect spot for a day out with family and friends."
    },
    {
      "title": "Shri Chatushrungi Devi Temple",
      "description": "Situated close to Aundh, this temple is dedicated to Goddess Chatushrungi and is one of Pune's most revered spiritual sites. It is located on a hill and involves a climb of over 100 steps, offering both divine blessings and scenic city views."
    },
    {
      "title": "Botanical Garden",
      "description": "The Aundh Botanical Garden is a peaceful green space perfect for morning walks, jogging, and leisure time. With water streams, fountains, and shaded pathways, it serves as a relaxing retreat for nature lovers."
    },
    {
      "title": "April Rain Restaurant",
      "description": "April Rain is a fine-dining restaurant located in Aundh, known for its sophisticated ambiance and diverse multi-cuisine menu. It is a popular venue for both casual dining and special occasions."
    },
    {
      "title": "Cinépolis IMAX",
      "description": "Located inside Westend Mall, Cinépolis offers a premium cinematic experience with cutting-edge sound and visuals. It's a favorite among moviegoers in the Aundh area."
    },
    {
      "title": "Picantos Mexican Grill",
      "description": "A cozy and vibrant restaurant offering authentic Mexican cuisine, Picantos is a hidden gem in Aundh. It's popular among foodies looking for tacos, burritos, and nachos with a twist."
    },
    {
      "title": "Hoppipola Aundh",
      "description": "Known for its lively decor, board games, and fusion menu, Hoppipola is a trendy hangout for youngsters. It’s ideal for brunches, casual meetings, or evening outings with friends."
    },
    {
      "title": "Ozone Mall (Spencer’s)",
      "description": "Though smaller than Westend, Ozone Mall serves local shoppers with retail stores, Spencer’s hypermarket, and basic fashion and electronics outlets. It’s a convenient stop for quick errands."
    },
    {
      "title": "IT Park at Aundh",
      "description": "Aundh is gradually growing as a minor IT hub with coworking spaces and offices like Smartworks and Regus. It is especially favored by startups due to its prime location and connectivity."
    },
    {
      "title": "Aundh BRTS Road & Food Lane",
      "description": "The main road along Aundh’s BRTS corridor is lined with cafes, snack stalls, and restaurants, making it a hotspot for food lovers. From street food to gourmet kitchens, this area offers it all."
    }
  ],
    "services": [
    {
      "name": "Corporate Transport Solutions in Aundh",
      "description": "eTravo offers customized corporate transport solutions in Aundh to meet the evolving mobility needs of modern businesses. Whether you're a startup, SME, or large enterprise, we provide structured and scalable services, including employee commute, executive cab hire, and inter-office transfers. Our fleet is equipped with GPS tracking, and our drivers are professionally trained to ensure punctual, safe, and reliable travel every day."
    },
    {
      "name": "Office Commute Bus and Cab Services Aundh",
      "description": "Simplify daily office commutes in Aundh with eTravo’s efficient bus and cab services tailored for corporate use. We offer fixed-route and shift-based travel plans that reduce commuting stress and boost employee productivity. With a fleet of AC cabs, minibuses, and coaches, we ensure comfortable and consistent pick-up and drop services backed by real-time tracking and on-call customer support."
    },
    {
      "name": "Daily Employee Shuttle in Aundh",
      "description": "eTravo’s daily employee shuttle service in Aundh provides a dependable and cost-effective commuting solution for your workforce. Our shuttle plans are optimized for location clusters, time slots, and employee volume. All vehicles are regularly sanitized, air-conditioned, and tracked for safety and punctuality. It's the perfect way to ensure consistent transport while improving employee satisfaction and attendance."
    },
    {
      "name": "Business Travel Cab Hire in Aundh",
      "description": "Need a reliable cab for client visits, meetings, or executive travel in Aundh? eTravo offers flexible business travel cab hire services with a fleet of sedans, SUVs, and premium cars. Our professional drivers, clean interiors, and punctual service make us the preferred choice for corporate travel. Book hourly, daily, or on-demand with transparent billing and support throughout the trip."
    },
    {
      "name": "Reliable Staff Transportation Aundh",
      "description": "Ensure safe and timely movement of your team with eTravo’s reliable staff transportation services in Aundh. Our services cater to various business sectors and are adaptable to changing shift schedules or operational needs. We provide both cab and bus transport options, equipped with route monitoring, live tracking, and proactive coordination to guarantee smooth and efficient employee mobility."
    },
    {
      "name": "Corporate Event Bus Services Aundh",
      "description": "Hosting a corporate event or offsite in or around Aundh? eTravo offers organized bus services to handle event transportation from start to finish. From planning vehicle capacity to managing arrival schedules, our event transport team ensures smooth coordination. Our buses are equipped with AC, spacious seating, and onboard support to ensure a professional and comfortable journey for your attendees."
    },
    {
      "name": "Budget Corporate Bus Rentals Aundh",
      "description": "Get access to cost-effective transport solutions with eTravo’s budget corporate bus rentals in Aundh. Ideal for small- to medium-sized teams or group movements, our rental packages are designed to offer maximum value without compromising comfort or reliability. Our clean, air-conditioned buses with experienced drivers are perfect for daily routes, one-time corporate outings, or temporary transport requirements."
    }
  ],
  "tableData": [
    ["Corporate Transport Solutions in Aundh", "Office Commute Bus and Cab Services Aundh"],
    ["Daily Employee Shuttle in Aundh", "Business Travel Cab Hire in Aundh"],
    ["Reliable Staff Transportation Aundh", "Corporate Event Bus Services Aundh"],
    ["Budget Corporate Bus Rentals Aundh", ""]
  ],







"whychoose": [
    {
        "WhyChooseheading": "Timely and Dependable Corporate Transport in Aundh",
        "WhyChoosedescription": "eTravo is known for its punctual and consistent service, helping businesses in Aundh manage daily commutes, client pickups, and event transportation with absolute reliability. Our drivers and operations team ensure that your team reaches every destination on schedule, without any delays or last-minute surprises."
    },
    {
        "WhyChooseheading": "Premium Fleet for Every Business Requirement",
        "WhyChoosedescription": "From luxury sedans for senior executives to spacious, air-conditioned buses for employee shuttles, our diverse vehicle fleet is designed to meet the unique travel needs of businesses in Aundh. Each vehicle is well-maintained, comfortable, and equipped with amenities that promote a relaxed and productive travel experience."
    },
    {
        "WhyChooseheading": "Professional Drivers with Local Expertise",
        "WhyChoosedescription": "Our drivers are trained professionals who understand the expectations of corporate clients. With excellent knowledge of Aundh’s traffic routes and shortcuts, they ensure safe, efficient, and courteous service—creating a reliable travel experience for your staff and clients alike."
    },
    {
        "WhyChooseheading": "Upfront Pricing with No Hidden Costs",
        "WhyChoosedescription": "We believe in full pricing transparency. With eTravo’s corporate cab and bus services in Aundh, you get clear, competitive rates with no hidden fees or unexpected charges. Our detailed pricing helps businesses plan effectively without compromising on service quality."
    },
    {
        "WhyChooseheading": "Safety-First Travel Experience",
        "WhyChoosedescription": "Your team’s safety is our top priority. All our vehicles are equipped with GPS tracking, seat belts, fire extinguishers, and first-aid kits. We also conduct regular safety inspections and sanitization, ensuring every journey within or outside Aundh is secure and hygienic."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Service Flexibility",
        "WhyChoosedescription": "Business schedules can change in a moment—and we’re ready for that. eTravo provides round-the-clock support and highly flexible scheduling options for pickups, drop-offs, and last-minute adjustments. We’re always available to match your corporate travel needs in Aundh."
    },
    {
        "WhyChooseheading": "Simple, Streamlined Booking Process",
        "WhyChoosedescription": "With our easy-to-use online platform, booking a cab or bus in Aundh is fast and efficient. You can manage schedules, track rides, and make adjustments in real-time, or get support from our team for group bookings and special travel requests."
    },
    {
        "WhyChooseheading": "Tailor-Made Corporate Travel Packages",
        "WhyChoosedescription": "We understand that no two companies are the same. eTravo offers fully customizable corporate travel solutions in Aundh—whether you need daily staff transport, client transfer services, or transport for seminars, conferences, and offsites. We adapt to your exact needs with precision and professionalism."
    }
]






















    }


   


// Corporate Cab and Bus Services in Aundh – eTravo

const faqData = [
    [
        {
            question: 'What corporate transportation solutions does eTravo offer in Aundh?',
            answer: 'eTravo provides professional cab and bus services in Aundh for corporate clients, including employee transportation, executive pickups, corporate event travel, and scheduled shuttle services.',
        },
        {
            question: 'Can eTravo manage daily employee transport for offices located in Aundh?',
            answer: 'Yes, we offer customized daily staff commute solutions with well-planned routes and fixed schedules using both premium cabs and AC buses to meet your company’s operational needs.',
        },
        {
            question: 'What vehicle types are available for corporate clients in Aundh?',
            answer: 'Our fleet includes executive cabs, SUVs, tempo travellers, and AC buses of various seating capacities — all maintained to deliver comfort, cleanliness, and professional-grade service.',
        },
        {
            question: 'Are your corporate transportation services GPS-enabled and trackable?',
            answer: 'Yes, all eTravo vehicles are GPS-enabled. Clients have access to real-time tracking dashboards and receive automated trip summaries and usage reports for transparency and security.',
        },
        {
            question: 'Does eTravo provide transportation for corporate events and client meetings in Aundh?',
            answer: 'Absolutely. We offer flexible booking for conferences, offsite meetings, VIP visits, and business tours, ensuring timely, courteous, and reliable service every time.',
        },
        {
            question: 'Is dedicated account management available for corporate clients in Aundh?',
            answer: 'Yes, we assign a dedicated account manager to each corporate client to handle ongoing transport logistics, support requests, and reporting needs efficiently.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Arvind Kulkarni',
        designation: 'Admin Lead, BrightEdge Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s services in Aundh have been incredibly helpful in streamlining our staff commute. The cabs and buses are always on time, and the quality of service is excellent.”',
    },
    {
        name: 'Ms. Sneha Gawande',
        designation: 'HR Executive, CodeAxis Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve partnered with eTravo for over a year now for our Aundh office transport. Their professional drivers, clean vehicles, and real-time tracking make them a reliable partner.”',
    },
];






















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Aundh",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-aundh.jpg",
  "description": "Book corporate cab and bus services in Aundh with eTravo for daily employee shuttles, office commute, and corporate event transportation. Affordable and reliable AC vehicles with professional drivers to meet all your business travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2745"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-aundh"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Aundh | Staff Transport & Business Travel | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Aundh with eTravo for employee shuttles, office commutes, and corporate events. Reliable, affordable, and professional transportation solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/8.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusaundh;